import { useDataSubmit } from 'Simple/Data.js'
import { isUnscheduledAppointment, timeToMinutes } from 'Data/format.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props) {
  let submit = useDataSubmit({
    context: 'appointment_overlay',
    viewPath: props.viewPath,
  })

  return async function onChange(value) {
    if (!value) return
    let booking = !isUnscheduledAppointment(value) ? value.booking?.[0] : null
    await submit({
      type: 'setExistingAppointment',
      is_external: true,
      id: value._id,
      type_id: value.type._id,
      type_name: value.type.display_name,
      treatment_id: value.tx._id,
      patient_id: value.patient._id,
      duration: booking ? booking.duration : value.duration,
      notes: value.notes,
      booking: booking
        ? {
            start_min: timeToMinutes(booking.local_start_time),
            date: booking.local_start_date,
            chair_id: booking.chair._id,
            location_id: booking.chair.resource.organization._id,
          }
        : null,
    })
  }
}
